module.exports = __webpack_public_path__ + "img/cta-food-mob-nl.6a74ed9b.png";